import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faCube } from '@fortawesome/pro-solid-svg-icons';
import { Accordion } from 'react-bootstrap-5';

import { ProjectPropTypes } from 'components/project/prop_types';
import { LeaseSpacesMediaPropTypes } from 'bundles/project/components/media_tab/media_props_types';
import MediaPhotoForm from 'bundles/project/components/media_tab/media_photo_form';
import VisualMediaForm from 'bundles/project/components/media_tab/visual_media_form';
import LeaseMediaLinks from 'bundles/project/components/media_tab/lease_spaces/lease_media_links';
import FloorPlan from 'components/floor_plan/floor_plan';

export default function LeaseSpacesMedia({
  leaseSpacesMedia,
  mediaUiUpdate,
  project,
  syndication,
  ovalroomGroupAdmin,
  visualMediaTypeOptions,
  onPhotoChange,
  onCustomerVisualMediaChange,
  onMediaLinksChange,
  onVisualMediaChange,
}) {
  const getVisualMediaEmbedsForUser = (leaseData = null) => {
    return ovalroomGroupAdmin ? leaseData.visualMediaEmbeds : leaseData.visualMediaEmbedsForCustomer;
  };
  const showVisualMediaEmbeds = (leaseData) => {
    return ovalroomGroupAdmin || getVisualMediaEmbedsForUser(leaseData).length > 0;
  };
  const getLeaseMediaLinksValues = data => ({
    floorPlan: data.floorPlan,
    matterportUrl: data.matterportUrl || '',
    videoUrl: data.videoUrl || '',
    virtualTourUrl: data.virtualTourUrl || '',
  });

  return (
    <div className="lease-spaces-container">
      <h3 className="mt-5 mb-5">
        {
          !mediaUiUpdate && <FontAwesomeIcon className="text-primary mr-2" icon={faCube}/>
        }
        Lease Spaces
      </h3>
      <Accordion alwaysOpen>
        {project.leaseSpaceListings.map((leaseListing, index) => {
          const leaseData = leaseSpacesMedia.find(item => item.id === leaseListing.leaseSpace.id);
          const leaseStatusClass = leaseListing.leaseStatusLabel.toLowerCase().replaceAll(' ', '-');

          return (
            <Accordion.Item
              bsPrefix={`panel panel-default ${leaseStatusClass}`}
              eventKey={index}
              key={leaseListing.id}
            >
              <Accordion.Header bsPrefix="panel-heading p-0">
                {leaseListing.address2Label}
                <span className="ml-3 fw-normal">{leaseListing.spaceSizeLabel}</span>
                <div className="status-container">
                  <span className="lease-deal-status-label mr-3">{leaseListing.leaseStatusLabel}</span>
                  <FontAwesomeIcon className="arrow-icon" icon={faChevronDown}/>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <MediaPhotoForm
                  basePhotoFormProps={leaseData.photoProps}
                  bulkDownloadPhotosLink={leaseListing.bulkDownloadPhotosLink}
                  mediaUiUpdate={mediaUiUpdate}
                  name={`lease-photo-form-${leaseListing.id}`}
                  photoEditorUrl={leaseData.photoProps.photoEditorUrl}
                  photos={leaseData.photoProps.photoAttachments}
                  showEdit={true}
                  showLimit={true}
                  syndication={syndication}
                  onPhotoChange={newPhotos => onPhotoChange(newPhotos, leaseData.id)}
                />

                <div className="form-group py-4">
                  <label className="control-label">
                    Floor Plan
                    <span className="ml-1 text-muted">(limit: 1)</span>
                  </label>
                  <div className="form-input-container">
                    <FloorPlan
                      floorPlan={leaseData.floorPlan}
                      mediaUiUpdate={mediaUiUpdate}
                      onChange={data => onMediaLinksChange('floorPlan', data, leaseData.id)}
                    />
                  </div>
                </div>

                {
                  showVisualMediaEmbeds(leaseData) &&
                  <VisualMediaForm
                    customerEmbeds={leaseData.visualMediaEmbedsForCustomer}
                    embeds={leaseData.visualMediaEmbeds}
                    mediaUiUpdate={mediaUiUpdate}
                    ovalroomGroupAdmin={ovalroomGroupAdmin}
                    parentName={`property[lease_spaces_attributes][${index}]`}
                    visualMediaTypeOptions={visualMediaTypeOptions}
                    onCustomerEmbedsChange={embeds => onCustomerVisualMediaChange(embeds, leaseData.id)}
                    onEmbedsChange={embeds => onVisualMediaChange(embeds, leaseData.id)}
                  />
                }

                <LeaseMediaLinks
                  mediaLinksFormFields={getLeaseMediaLinksValues(leaseData)}
                  onFormChange={(key, value) => onMediaLinksChange(key, value, leaseData.id)}
                />
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
}

LeaseSpacesMedia.propTypes = {
  leaseSpacesMedia: LeaseSpacesMediaPropTypes,
  mediaUiUpdate: PropTypes.bool,
  ovalroomGroupAdmin: PropTypes.bool.isRequired,
  project: ProjectPropTypes.isRequired,
  syndication: PropTypes.bool.isRequired,
  visualMediaTypeOptions: PropTypes.array.isRequired,
  onCustomerVisualMediaChange: PropTypes.func.isRequired,
  onMediaLinksChange: PropTypes.func.isRequired,
  onPhotoChange: PropTypes.func.isRequired,
  onVisualMediaChange: PropTypes.func.isRequired,
};
